import React, { FC } from 'react';
import Skeleton from '@mui/material/Skeleton';

const COESkeletonComponent: FC = () => {
  return (
    <>
      <Skeleton />
      <Skeleton animation="wave" />
      <Skeleton animation={false} />
    </>
  );
};

export default COESkeletonComponent;
